function readVideoFlag(video, name, fallback = false) {
    const value = video.getAttribute(name);
    if (value === null) {
        return fallback;
    }

    return value === '1' || value === 'true';
}

function pauseOnLastFrame(video) {
    const duration = video.duration;
    if (!Number.isFinite(duration) || duration <= 0) {
        video.pause();
        return;
    }

    video.currentTime = Math.max(duration - 0.04, 0);
    video.pause();
}

function ensureVideoSource(video) {
    const source = video.querySelector('source[data-src]');
    if (!source || source.getAttribute('src')) {
        return Promise.resolve();
    }

    source.setAttribute('src', source.getAttribute('data-src'));
    video.load();

    return new Promise((resolve) => {
        if (video.readyState >= 1) {
            resolve();
            return;
        }

        video.addEventListener('loadedmetadata', resolve, { once: true });
    });
}

function bindSectionVideo(video) {
    const loop = readVideoFlag(video, 'data-koch-video-loop');
    const playOnScroll = readVideoFlag(video, 'data-koch-video-scroll', true);
    const pauseOnEnd = readVideoFlag(video, 'data-koch-video-pause-on-end', true);

    if (!loop && pauseOnEnd) {
        video.addEventListener('ended', () => {
            pauseOnLastFrame(video);
        });
    }

    if (!playOnScroll) {
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    video.muted = true;

    const root = video.closest('section') || video;

    if (!('IntersectionObserver' in window)) {
        ensureVideoSource(video).then(() => {
            video.play().catch(() => {});
        });
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    ensureVideoSource(video).then(() => {
                        video.play().catch(() => {});
                    });
                    return;
                }

                video.pause();
            });
        },
        {
            threshold: 0.35,
            rootMargin: '0px 0px -10% 0px',
        }
    );

    observer.observe(root);
}

export function initSectionVideos(root = document) {
    root.querySelectorAll('[data-koch-section-video]').forEach((video) => {
        bindSectionVideo(video);
    });
}
